import React from 'react'

const ServiceLocation = (prop) => (
  <div className="service-locations" style={{ display: 'flex' }}>
                        <div style={{ width: '20%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img className="img-responsive" style={{ maxHeight: 65 }} src={prop.locationImage}></img>
                        </div>
                        <div style={{ width: '80%'}}>
                          { prop.location }
                        </div>
                      </div>
)

export default ServiceLocation